// extracted by mini-css-extract-plugin
export var content = "ConferenceVideoSectionLeft-module--content--d2eca";
export var videoWrapper = "ConferenceVideoSectionLeft-module--videoWrapper--9f0d5";
export var wrapper = "ConferenceVideoSectionLeft-module--wrapper--81038";